var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.user_role !== 'guest')?_c('div',{staticClass:"text-center mt-1"},[_c('vx-tooltip',{staticClass:"inline-flex",attrs:{"text":'View',"position":"bottom"}},[_c('feather-icon',{attrs:{"icon":"EyeIcon","svgClasses":`h-4 w-4 cursor-pointer`},on:{"click":function($event){return _vm.viewActivity()}}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }